<template>
  <div class="goods-analysis-page">
    <div class="contain">
      <div class="search_box">
        <top-title :classType="1" :name="name"></top-title>
        <div class="time-box">
          <searchCondition
            title="付款时间"
            :currenttime="mytime"
            :activeInd="activeInd"
            :defaultActIndex="7"
            :limit="btnLoading"
            :showReset="true"
            :isShowOne="false"
            :isShowFifteen="true"
            :dayTime="90"
            v-on:search="handleSearch"
            v-on:changeTime="recent_time"
            v-on:setTime="handleSetTime"
          ></searchCondition>
        </div>
      </div>
      <div class="tab_box">
        <!-- 按钮 -->
        <div class="btn_all">
          <div class="left">
            <div class="btn">
              <span class="btn_tit" @click="isShowGoods = true"
                >添加分析商品</span
              >
            </div>
            <div class="btn">
              <span class="btn_tit" @click="handleDelete">移除</span>
            </div>
          </div>
          <div class="right" style="margin-top: -6px">
            <el-button
              type="primary"
              class="status_btn status_btn2"
              @click="seacherResultCare"
              >导出</el-button
            >
          </div>
        </div>

        <!-- 表格 -->
        <div class="table-box">
          <el-table
            ref="goodsAnalysisTable"
            :data="tableData"
            style="width: 100%; margin-top: 22px"
            :header-cell-style="{ background: '#fafafa' }"
            max-height="700px"
            v-loading="tableLoading"
            @selection-change="handleSelectionChange"
          >
            <!-- 暂无数据修改 -->
            <template slot="empty">
              <div>
                <img src="../../assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <!-- 选择器 -->
            <el-table-column type="selection" width="55"></el-table-column>
            <!-- 表头 -->
            <el-table-column
              v-for="(item, index) in tableInfo"
              :key="'tableInfo' + index"
              :label="item.label"
              :prop="item.prop"
            >
              <!-- 商品信息自定义 -->
              <template slot="header" v-if="item.label == '商品信息'">
                <span>{{ item.label }}</span>
                <span
                  style="color: #fe4d45; cursor: pointer"
                  @click="allShow = true"
                  v-if="!allShow"
                  >（展开全部）</span
                >
                <span
                  style="color: #fe4d45; cursor: pointer"
                  @click="allShow = false"
                  v-else
                  >（收起全部）</span
                >
              </template>
              <template slot-scope="scope">
                <template v-if="item.label == '商品信息'">
                  <div v-if="!allShow">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.skuName"
                      placement="top"
                    >
                      <div
                        class="itemTitle hoveTitle"
                        :style="{
                          color: '#333',
                          // 'text-decoration': 'underline',
                        }"
                      >
                        {{ scope.row.skuName }}
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="`${scope.row.skuId}`"
                      placement="top"
                    >
                      <div class="hoveTitle" :style="{
                  color: '#999',
                }">SKU ID:{{ scope.row.skuId }}</div>
                    </el-tooltip>
                  </div>
                  <div v-if="allShow">
                    <div
                      class="itemTitle"
                      :style="{
                        color: '#333',
                        // 'text-decoration': 'underline',
                      }"
                    >
                      {{ scope.row.skuName }}
                    </div>
                    <div :style="{
                  color: '#999',
                }">SKU ID:{{ scope.row.skuId }}</div>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <!-- 下划线 -->
                    <span
                      class="num-tip"
                      v-if="
                        item.label == '连带其他商品人数' ||
                        item.label == '回购其他商品人数'
                      "
                      @click="showDialog(item.prop, item.label, scope.row)"
                    >
                      {{ scope.row[`${item.prop}`] }}
                    </span>
                    <span v-else>
                      {{ scope.row[`${item.prop}`] }}
                    </span>
                  </div>
                </template>
              </template>
            </el-table-column>
          </el-table>

          <div
            style="
              padding: 20px 28px 30px;
              text-align: right;
              margin-bottom: 0px;
            "
          >
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 50, 100, 500, 1000]"
              :total="pageInfo.total"
              :page-size="pageInfo.size"
              :current-page="pageInfo.current"
              :disabled="tableLoading"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成报表 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1="handleExport"
    ></generate>

    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="isShowGoods"
      :isShow="isShowGoods"
      :selectGoods="skuList"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>

    <!-- 表格内弹框 -->
    <el-dialog
      v-if="dialogTableVisible"
      :visible.sync="dialogTableVisible"
      :title="title"
      class="dialog-table-box"
      width="800px"
      @close="close"
    >
      <el-table
        :data="dialogTableData"
        style="width: 100%"
        max-height="500px"
        :header-cell-style="{ background: '#fafafa' }"
        v-loading="dialogTableLoading"
      >
        <!-- 暂无数据修改 -->
        <template slot="empty">
          <div>
            <img src="../../assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <!-- 表头 -->
        <el-table-column
          v-for="(item, index) in dialogTabelInfo"
          :key="'dialogTabelInfo' + index"
          :label="item.label"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <template v-if="item.prop == 'product'">
              <div
                class="itemTitle"
                :style="{
                  color: '#333',
                  // 'text-decoration': 'underline',
                }"
              >
                {{ scope.row.skuName }}
              </div>
              <div :style="{
                  color: '#999',
                }">SKU ID:{{ scope.row.skuId }}</div>
            </template>
            <template v-else>
              <div>
                {{ scope.row[`${item.prop}`] }}
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="padding: 20px 28px 30px; text-align: right; margin-bottom: 0px"
      >
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 50, 100, 500, 1000]"
          :total="dialogPagesInfo.total"
          :page-size="dialogPagesInfo.size"
          :current-page="dialogPagesInfo.current"
          :disabled="dialogTableLoading"
          @size-change="handleDialogSizeChange"
          @current-change="handleDialogCurrentChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topTitle from "@/components/top-title";
import searchCondition from "@/components/search-condition.vue";
import generate from "../../components/generate_report.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import {
  deleteSkuBatch,
  exportPerspective,
  getPerspectiveSkuPage,
  orderNumPage,
  otherNumPage,
  saveSkuBatchsaveSkuBatch,
} from "@/api/analysis/goods_analysis.js";
export default {
  components: {
    topTitle,
    searchCondition,
    generate,
    selectGoods,
  },
  computed: {
    name() {
      return this.$route.name;
    },
  },
  created() {
    this.buriedPoint(1, "商品交易透视", "数据分析", "商品分析");
  },
  data() {
    return {
      // 时间集合
      mytime: [],
      activeInd: 7,
      selectParams: {
        startTime: "",
        endTime: "",
      },
      form: {},
      // 时间选择加载
      btnLoading: false,
      // 表格加载
      tableLoading: false,
      // 分页数据
      pageInfo: {
        total: 0,
        current: 1,
        size: 10,
      },
      tableData: [],
      multipleSelection: [],
      tableInfo: [
        {
          label: "商品信息",
          prop: "commodityInfo",
        },
        {
          label: "购买人数",
          prop: "buyNum",
        },
        {
          label: "新客购买人数",
          prop: "newBuyNum",
        },
        {
          label: "老客购买人数",
          prop: "oldBuyNum",
        },
        {
          label: "连带其他商品人数",
          prop: "bindOtherNum",
        },
        {
          label: "回购本品人数",
          prop: "reBuyNum",
        },
        {
          label: "回购其他商品人数",
          prop: "reBuyOtherNum",
        },
      ],
      allShow: false, // 是否全部显示
      isAllShow: false,
      control: false,
      isShowGoods: false,
      skuList: [],
      selectGoodsArr: [],
      // 表格
      dialogTableVisible: false,
      dialogTableLoading: false,
      dialogTableData: [],
      dialogTabelInfo: [],
      dialogPagesInfo: {
        total: 0,
        current: 1,
        size: 10,
      },
      title: "",
      // 回购其他商品人数表头
      reGoodsInfo: [
        {
          label: "回购商品",
          prop: "product",
          width: "360",
        },
        {
          label: "购买人数",
          prop: "buyNum",
        },
        {
          label: "占比",
          prop: "rate",
        },
      ],
      //  连带其他商品人数表头
      relatedGoodsInfo: [
        {
          label: "连带商品",
          prop: "product",
          width: "360",
        },
        {
          label: "购买人数",
          prop: "buyNum",
        },
        {
          label: "占比",
          prop: "rate",
        },
      ],
      // 表格弹框类型判断
      otherType: "",
      // 当前表格skuId
      nowSkuId: "",
    };
  },
  mounted() {
    const date = [this.getDay(-7, "-"), this.getDay(-1, "-")];
    this.mytime = date;
    this.selectParams.startTime = this.mytime[0] + " 00:00:00";
    this.selectParams.endTime = this.mytime[1] + " 23:59:59";
    this.getTableData();
  },
  methods: {
    // 重置事件
    recent_time(i, isReset) {
      if (i === 1) {
        this.mytime = [this.getDay(-1, "-"), this.getDay(-1, "-")];
      } else if (i === 7) {
        this.mytime = [this.getDay(-7, "-"), this.getDay(-1, "-")];
      }  else if (i === 15) {
        this.mytime = [this.getDay(-15, "-"), this.getDay(-1, "-")];
      } else if (i === 30) {
        this.mytime = [this.getDay(-30, "-"), this.getDay(-1, "-")];
      }
      this.selectParams.startTime = this.mytime[0] + " 00:00:00";
      this.selectParams.endTime = this.mytime[1] + " 23:59:59";
      if (isReset) {
        this.pageInfo = {
          total: 1,
          current: 1,
          size: 10,
        };
        this.getTableData();
      }
    },
    // 监听查询按钮
    handleSearch(mytime) {
      if (mytime !== null) {
        if (mytime[0] !== null && mytime[1] !== null) {
          if (
            mytime[0].indexOf("00:00:00") != -1 &&
            mytime[1].indexOf("23:59:59") != -1
          ) {
            this.selectParams.startTime = mytime[0];
            this.selectParams.endTime = mytime[1];
          } else {
            this.selectParams.startTime = mytime[0] + " 00:00:00";
            this.selectParams.endTime = mytime[1] + " 23:59:59";
          }
          this.pageInfo = {
            total: 1,
            current: 1,
            size: 10,
          };
          this.getTableData();
        } else {
          this.$message.warning(`请补全时间`);
        }
      } else {
        this.selectParams.startTime = "";
        this.selectParams.endTime = "";
      }
    },
    // 自定义事件监听
    handleSetTime(mytime) {
      this.activeInd = 0;
      if (
        mytime.toString() ==
        [this.getDay(-1, "-"), this.getDay(-1, "-")].toString()
      ) {
        this.activeInd = 1;
      } else if (
        mytime.toString() ==
        [this.getDay(-7, "-"), this.getDay(-1, "-")].toString()
      ) {
        this.activeInd = 7;
      } else if (
        mytime.toString() ==
        [this.getDay(-15, "-"), this.getDay(-1, "-")].toString()
      ) {
        this.activeInd = 15;
      } else if (
        mytime.toString() ==
        [this.getDay(-30, "-"), this.getDay(-1, "-")].toString()
      ) {
        this.activeInd = 30;
      }
    },
    // 表格表头选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表格数据请求
    getTableData() {
      let params = {
        ...this.selectParams,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
      };
      // console.log("params", params);
      this.tableLoading = true;
      this.btnLoading = true;
      // this.tableData = [];
      orderNumPage(params)
        .then((res) => {
          if (res.code == 1) {
            let rdata = res.data;
            this.pageInfo.total = !!rdata.total? rdata.total : 0;
            this.pageInfo.size = !!rdata.size? rdata.size : 10;
            this.pageInfo.current = !!rdata.current? rdata.current: 1;
            this.tableData = !!rdata.records ? rdata.records: [];
            this.$message.success(res.message);
            this.tableLoading = false;
            this.btnLoading = false;
            // 表格选中清空
            this.$refs.goodsAnalysisTable.clearSelection();
          } else {
            this.$message.error(res.message);
            this.tableLoading = false;
            this.btnLoading = false;
            this.tableData = [];
            this.pageInfo = {
              total: 0,
              current: 1,
              size: 10,
            }
            // 表格选中清空
            this.$refs.goodsAnalysisTable.clearSelection();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.tableLoading = false;
          this.btnLoading = false;
          this.tableData = [];
          this.pageInfo = {
            total: 0,
            current: 1,
            size: 10,
          }
          // 表格选中清空
          this.$refs.goodsAnalysisTable.clearSelection();
        });
    },
    // 表格一页数量改变
    handleSizeChange(val) {
      this.pageInfo.current = 1;
      this.pageInfo.size = val;
      this.getTableData();
    },
    // 表格页数改变
    handleCurrentChange(val) {
      this.pageInfo.current = val;
      this.getTableData();
    },
    // 导出
    seacherResultCare() {
      this.control = true;
    },
    handleExport(val) {
      this.form.exportRemark = val;
      let params = {
        ...this.form,
        ...this.selectParams,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
      };
      exportPerspective(params)
        .then((res) => {
          // console.log("res", res);
          if (res.code == 1) {
            this.control = true;
            this.$message.success(res.message);
          } else {
            if (!!res.data.message) {
              this.$message.error(res.data.message);
            } else if (!!res.message) {
              this.$message.error(res.message);
            }
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    selectGoodsChange(val) {
      if (val) {
        if (val.length > 30) {
          this.$message.warning("sku上限为30个！");
          return;
        }
        val.forEach((item) => {
          this.selectGoodsArr.push(item.skuId);
        });
        this.skuList = val;
        // console.log("skuList", this.skuList);
        saveSkuBatchsaveSkuBatch(this.skuList)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.isShowGoods = false;
              this.skuList = [];
              this.pageInfo = {
                total: 0,
                current: 1,
                size: 10,
              };
              this.getTableData();
            } else {
              this.isShowGoods = false;
              this.$message.error(res.message);
              this.skuList = [];
              this.getTableData();
            }
          })
          .catch((err) => {
            this.isShowGoods = false;
            this.$message.error(err);
            this.skuList = [];
            this.getTableData();
          });
      } else {
        this.skuList = [];
        this.isShowGoods = false;
      }
    },
    showDialog(prop, label, val) {
      this.dialogPagesInfo = {
        total: 0,
        current: 1,
        size: 10,
      };
      this.title = label;
      switch (prop) {
        case "bindOtherNum": {
          // 连带其他商品人数
          this.dialogTabelInfo = this.relatedGoodsInfo;
          this.otherType = 1;
          break;
        }
        case "reBuyOtherNum": {
          // 回购其他商品人数
          this.dialogTabelInfo = this.reGoodsInfo;
          this.otherType = 2;
          break;
        }
        default:
          break;
      }
      this.nowSkuId = val.skuId;
      this.getDialogTableData(val);
      this.dialogTableVisible = true;
    },
    // 弹框请求
    getDialogTableData(val) {
      let params = {
        otherType: this.otherType,
        current: this.dialogPagesInfo.current,
        size: this.dialogPagesInfo.size,
        skuId: this.nowSkuId,
        ...this.selectParams,
      };
      this.dialogTableLoading = true;
      otherNumPage(params)
        .then((res) => {
          if (res.code == 1) {
            let rdata = res.data;
            this.dialogTableData = !!rdata.records? rdata.records: [];
            this.dialogPagesInfo = {
              total: !!rdata.total ? rdata.total: 0,
              current: !!rdata.current ? rdata.current: 1,
              size: !!rdata.size ? rdata.size: 10,
            };
            this.dialogTableLoading = false;
          } else {
            this.$message.error(res.message);
            this.dialogTableData = [];
            this.dialogTableLoading = false;
            this.dialogPagesInfo = {
              total: 0,
              current: 1,
              size: 10,
            }
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.dialogTableData = [];
          this.dialogPagesInfo = {
            total: 0,
            current: 1,
            size: 10,
          };
          this.dialogTableLoading = false;
        });
    },
    // 表格弹框关闭
    close() {
      // 清除表格数据
      this.nowSkuId = "";
      this.dialogTableData = [];
      this.dialogTabelInfo = [];
      this.dialogPagesInfo = {
        total: 0,
        current: 1,
        size: 10,
      };
      this.dialogTableVisible = false;
    },
    // 弹框表格一页数量改变
    handleDialogSizeChange(val) {
      this.dialogPagesInfo.current = 1;
      this.dialogPagesInfo.size = val;
      this.getDialogTableData();
    },
    // 弹框表格页数改变
    handleDialogCurrentChange(val) {
      this.dialogPagesInfo.current = val;
      this.getDialogTableData();
    },
    // 监听移除
    handleDelete() {
      if (this.multipleSelection.length > 0) {
        // console.log("this.multipleSelection", this.multipleSelection);
        let idList = [];
        this.multipleSelection.forEach((item) => {
          idList.push(item.id);
        });
        // let params = {
        //   ids: skuIdList,
        // };
        // console.log("params", params);
        // 发送请求移除商品
        deleteSkuBatch(idList)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.getTableData();
            } else {
              this.$message.error(res.message);
              this.getTableData();
            }
          })
          .catch((err) => {
            this.$message.error(err);
            this.getTableData();
          });
      } else {
        this.$message.error("您还未勾选，请进行勾选，再继续操作!");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Microsoft YaHei";
}
.goods-analysis-page {
  margin-top: 10px;
  .contain {
    box-sizing: border-box;
    padding: 0 20px;
    min-width: 1106px;
    .search_box {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      padding: 0px 0 30px 0;
      border-radius: 6px;
      .time-box {
        padding-left: 30px;
        padding-top: 30px;
      }
    }

    .tab_box {
      margin-top: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      padding: 24px 20px 20px 20px;
      border-radius: 6px;
      .btn_all {
        display: flex;
        margin-bottom: -5px;
        justify-content: space-between;
        .btn {
          box-sizing: border-box;
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          border-radius: 3px;
          margin-right: 8px;
          cursor: pointer;
          height: 32px;
          line-height: 20px;
          .btn_tit {
            height: 32px;
            border-radius: 5px;
            padding: 5px 12px 5px 12px;
            vertical-align: middle;
            color: #ffffff;
            background-color: #fe4d45;
            &:hover {
              color: #fff;
              opacity: 0.9;
              background-color: #fe4d45;
            }
          }
          .btn_tit1 {
            border-radius: 5px;
            padding: 5px 12px 5px 12px;
            vertical-align: middle;
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff;
            &:hover {
              color: #fff;
              border: 1px solid #fff;
              background-color: #fe4d45;
            }
          }
        }
        .status_btn {
          width: 98px;
          background-color: #fff;
          font-size: 14px;
        }
        .status_btn2 {
          margin-left: 20px;
          vertical-align: middle;
          border-radius: 5px;
          width: 98px;
          height: 32px;
          color: #666666;
          border: 1px solid #dddddd;
          background-color: #fff;
          &:hover {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
    }

    .table-box {
      .num-tip {
        text-decoration: underline;
        cursor: pointer;
      }

      .num-tip-s {
        text-decoration: underline;
      }
      .itemTitle {
        cursor: pointer;
      }
      .hoveTitle {
        text-align: left;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .dialog-table-box {
  }
}
</style>